/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './lockConvo.defs.js'
export { main as default } from './lockConvo.defs.js'
